import { useCompanyTypeFlags } from "./useCompanyTypeFlags"
import { useGetVendorPayableFields } from "./useGetVendorPayableFields"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface UseAccountsPayableBalancePermissionsParams {
  companyId: string
}

interface UseAccountsPayableBalancePermissionsReturn {
  canViewAccountsPayableBalance: boolean
  isFetching: boolean
}

export const useAccountsPayableBalancePermissions = ({
  companyId,
}: UseAccountsPayableBalancePermissionsParams): UseAccountsPayableBalancePermissionsReturn => {
  const { hasPermissions } = usePermissionManager()
  const { isCompanyVendor } = useCompanyTypeFlags()
  const { fields, isFetching, isResolved } = useGetVendorPayableFields(companyId, !isCompanyVendor)

  const requirements = fields.sensitiveAccount
    ? [[PermissionActionType.AP_BALANCE, PermissionActionType.SENSITIVE_ACCOUNT_MAINTENANCE]]
    : [PermissionActionType.AP_BALANCE]

  // `isResolved` is load-bearing: an unresolved read leaves sensitiveAccount null, which would
  // otherwise read as non-sensitive and expose the tab on a sensitive vendor.
  const canViewAccountsPayableBalance = isCompanyVendor && isResolved && hasPermissions(requirements)

  return { canViewAccountsPayableBalance, isFetching }
}
